module.exports = __webpack_public_path__ + "img/32.134600bb.jpg";